import { render, staticRenderFns } from "./dataShow.vue?vue&type=template&id=3e9f037c&scoped=true&"
import script from "./dataShow.vue?vue&type=script&lang=js&"
export * from "./dataShow.vue?vue&type=script&lang=js&"
import style0 from "./dataShow.vue?vue&type=style&index=0&id=3e9f037c&prod&lang=scss&"
import style1 from "./dataShow.vue?vue&type=style&index=1&id=3e9f037c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f037c",
  null
  
)

export default component.exports